import Vue from "vue";
import store from "@/store";
export default {
  install() {
    Vue.prototype.$bet = {
      //
      // Get Bet Agente (return only bet data)
      //
      getBetAgent: async (id_bet, printed) => {
        const { nivel } = Vue.prototype.$localStorage.getItem("user_data");
        const endPoints = {
          3: "localManager/bets/getBetAgent",
          4: "regionalManager/bets/getBetAgent",
          6: "administrator/bets/getBetAgent",
          8: "colab/bets/getBetAgent",
        };

        const endpoint = endPoints[nivel];
        const params = {
          id_bet: Number(id_bet),
          printed: printed ? printed : "",
        };
        try {
          const response = await requestApi(endpoint, params);
          const betData = response.data.dados[0];
          const agentData = response.data.agent
            ? response.data.agent
            : response.data.player;
          store.commit("setBetCard", {
            betData,
            agentData,
          });
          return {
            status: response.status,
            betData,
          };
        } catch (error) {
          const err = error;
          throw err;
        }
      },

      //
      // Get Bet Player (return only bet data)
      //
      getBetPlayer: async (id_bet) => {
        const user_data = JSON.parse(localStorage.getItem("user_data"));

        const endpoint = user_data.isCollaborator
          ? "colab/bets/getBetPlayer"
          : "administrator/bets/getBetPlayer";

        const params = {
          id_bet: Number(id_bet),
        };
        try {
          const response = await requestApi(endpoint, params);
          const betData = response.data.dados[0];
          const playerData = response.data.player;
          store.commit("setBetCard", {
            betData,
            playerData,
          });
          return {
            status: response.status,
            betData,
          };
        } catch (error) {
          const err = error;
          throw err;
        }
      },

      //
      // Show Bet Dialog:
      // Open dialog with betcard and return betdata
      //
      showBetDialog: async (id_bet, printed, payBet = false) => {
        await Vue.prototype.$bet.getBetAgent(id_bet, printed);
        store.commit("showBetDialog", true);
        store.commit("payingBet", payBet);
      },

      //
      // Show Bet Dialog Online:
      // Open dialog with betcard and return betdata
      //
      showBetDialogOnline: async (id_bet) => {
        await Vue.prototype.$bet.getBetPlayer(id_bet);
        store.commit("showBetDialog", true);
        store.commit("payingBet", false);
      },
    };
  },
};

// Constructor Request Api
const requestApi = (endpoint, params) => {
  store.commit("setFeedbackProgress", true);
  return new Promise((resolve, reject) => {
    Vue.prototype.$axios
      .post(`${endpoint}`, Vue.prototype.$formdata(params))
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        store.commit("setFeedbackProgress", false);
        reject(error);
      });
  });
};
